import { createFileRoute, Outlet } from "@tanstack/react-router";
import { bookmarkListInfiniteQueryOptions } from "~/features/favorites/api";
import { footprintListInfiniteQueryOptions } from "~/features/footprint/api";
import { myProfileQueryOptions } from "~/features/myProfile/api";
import { MyProfileTemplate } from "~/features/myProfile/MyProfileTemplate";

// マイページ layout route。
// MyProfileTemplate を常時マウントし、子ルート（bookmarks/footprint 等）を
// 全画面オーバーレイ（fixed inset-0）で重ねることで戻り遷移の白点滅を防ぐ。
const MyPageLayout = () => (
  <>
    <MyProfileTemplate />
    <Outlet />
  </>
);

export const Route = createFileRoute("/_authenticated/my-page")({
  loader: ({ context: { queryClient } }) =>
    Promise.all([
      queryClient.ensureQueryData(myProfileQueryOptions),
      queryClient.ensureInfiniteQueryData(footprintListInfiniteQueryOptions),
      queryClient.ensureInfiniteQueryData(bookmarkListInfiniteQueryOptions),
    ]),
  component: MyPageLayout,
});
